export const RequirementFlags = [
  {
    key: "Always",
    text: "Always",
    value: "Always",
  },
  {
    key: "IsPortRequest",
    text: "IsPortRequest",
    value: "IsPortRequest",
  },
  {
    key: "IsDA15589User",
    text: "IsDA15589User",
    value: "IsDA15589User",
  },
  {
    key: "IsNotDA15589User",
    text: "IsNotDA15589User",
    value: "IsNotDA15589User",
  },
  {
    key: "DataElementCode0",
    text: "DataElementCode0",
    value: "DataElementCode0",
  },
  {
    key: "DataElementCode1",
    text: "DataElementCode1",
    value: "DataElementCode1",
  },
  {
    key: "DataElementCode2",
    text: "DataElementCode2",
    value: "DataElementCode2",
  },
  {
    key: "DataElementCode3",
    text: "DataElementCode3",
    value: "DataElementCode3",
  },
  {
    key: "DataElementCode4",
    text: "DataElementCode4",
    value: "DataElementCode4",
  },
  {
    key: "Divider",
    text: "Divider",
    value: "Divider",
  },
];
